import React from "react";
import { connect } from "react-redux";
import arcone from "assets/images/leftarc.svg";
import rightarc from "assets/images/rightarc.svg";
import woman from "assets/images/woman.png";
import {
  Box,
  Grid,
  Card,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SubFooterView from "components/SubFooterView";
import FooterView from "./FooterView";
import mobileTopArc from "assets/images/mobile-top-curve.svg";

const CouponDetailsTemplate = (props) => {
  const { children, positionTop, pageTitle, minHeight, organizationInfo } =
    props;
  const theme = useTheme();
  const matchesMd = useMediaQuery(theme.breakpoints.down("md"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";
  return (
    <Box>
      {isShowBackgroundAssets && (
          <Box sx={{ display: matchesMd ? "block" : "none" }}>
            <img
              src={mobileTopArc}
              alt="mabile-arc"
              className="left-mobile-arc"
              style={{ transform: "rotate(180deg)" }}
            />
          </Box>
        )}
      <Grid container>
        <Grid
          item
          container
          sx={{
            minHeight: minHeight || "400px",
          }}
        >
          {isShowBackgroundAssets && (
              <>
                <Box sx={{ display: matchesMd ? "none" : "block" }}>
                  <img
                    src={arcone}
                    alt="top"
                    className="search-medication-top-curve"
                  />
                </Box>
                <Box sx={{ display: matchesMd ? "none" : "block" }}>
                  <img src={rightarc} alt="top" className="right-arc" />
                </Box>
              </>
            )}
          <Grid item container>
            <Grid item md={12} lg={7} xs={12}>
              <Box
                sx={{
                  height: matchesMd ? undefined : "60px",
                  width: "65%",
                  display: "flex",
                  alignItems: "center",
                  margin: "auto",
                  marginBottom: "6px",
                }}
              >
                <Typography variant="text2">{pageTitle || ""}</Typography>
              </Box>
              <Box
                sx={{
                  width: matchesMd ? "100%" : "90%",
                  margin: "auto",
                  paddingTop: positionTop,
                  position: "relative",
                }}
              >
                <Card>
                  <Box sx={{ height: "100%" }}>{children}</Box>
                </Card>
              </Box>
            </Grid>
            <Grid
              item
              lg={5}
              sx={{
                position: "relative",
                overflow: "hidden",
                display: {
                  xl: "block",
                  lg: "block",
                  md: "none",
                  sm: "none",
                  xs: "none",
                },
              }}
            >
              <Box
                sx={{
                  marginTop: "5rem",
                  display: {
                    xl: "block",
                    lg: "block",
                    md: "none",
                    sm: "none",
                    xs: "none",
                  },
                }}
              >
                <img
                  src={woman}
                  alt="top"
                  style={{ width: "44%", marginLeft: "35%" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={12} sx={{ marginTop: "2rem" }}>
          <SubFooterView />
          <FooterView />
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(CouponDetailsTemplate);
